import { createContext } from 'react';
import {
  TProjectConfiguration,
  TProjectConfigurationGeneralItem,
  TProjectConfigurationParameter,
} from 'pages/common/types';
import {
  TPatchProjectPayload,
  TSavedProjectsComplimentaryGroup,
} from 'pages/saved-project-configuration/types';
import { TService } from 'pages/dimensions/store/dimensions';
import { TApi } from 'utils/api';

export type TPatchProjectCallBack = (payload: TPatchProjectPayload) => Promise<void>;

export type TPresaleActionHandler = (
  project: TProjectConfiguration,
  patchProjectCallBack: TPatchProjectCallBack
) => void | Promise<void>;

export type TData = {
  id: string;
  projectStatus: string;
  regionId: number;
  generalItems: Array<TProjectConfigurationGeneralItem>;
  projectConfigurationParameters?: Array<TProjectConfigurationParameter>;
  complimentaryGroups?: Array<TSavedProjectsComplimentaryGroup>;
  services?: TService[];
  presaleProps?: {
    onQuotationButtonClick?: TPresaleActionHandler;
    onCartButtonClick?: TPresaleActionHandler;
    isCartButtonLoading?: boolean;
    isQuotationButtonLoading?: boolean;
    regionId?: number;
  };
  env: {
    ORCHESTRATOR_HOST: string;
    API_KEY: string;
  };
  api: TApi;
};

export type TDataContext = {
  data: TData | null;
  setData: React.Dispatch<React.SetStateAction<TData>>;
};

type TRouteContext = {
  route: string | null;
  setRoute: React.Dispatch<React.SetStateAction<string>>;
};

export const DataContext = createContext<TDataContext>({
  data: null,
  setData: () => {
    // empty initial function
  },
});

export const RouteContext = createContext<TRouteContext>({
  route: null,
  setRoute: () => {
    // empty initial function
  },
});
